import * as React from 'react';
import { Input, Button, Label, Modal, Form, Radio } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth, { OAuthClientStatus } from '../../../api';
import Toast from '../../../sys/toast';
const fileDownload = require('js-file-download');

type FileType = 'config' | 'alias' | 'vodAlias';

class State {
    file: any;
    showModal: boolean;
    fileType: string;
    importValue: FileType;
    exportValue: FileType;
}

interface Props {

}

export default class DownloadUploadPanel extends React.Component<Props, State> {
    componentWillMount() {
        this.setState({
            file: null,
            showModal: false,
            fileType: '',
            importValue: 'config',
            exportValue: 'config'
        });
        this.handleWarningClose = this.handleWarningClose.bind(this);
    }

    onImportConfigFile(e: any, option: FileType) {
        e.preventDefault();
        const url = 'http://default/api/filedownload';
        let type = ''; let validFileExt = true;
        let formData = new FormData();
        let fileType = '';

        const prettyType = this.prettyFileType(option);
        if (this.state.file) {
            if (option === 'alias') {
                type = '1';
                if (!(this.state.file.name.endsWith('.tsv'))) {
                    fileType = '.tsv';
                    validFileExt = false;
                }
            } else if (option === 'config') {
                type = '2';
                if (!(this.state.file.name.endsWith('.ini'))) {
                    fileType = '.ini';
                    validFileExt = false;
                }
            } else { // option === 'vodAlias'
                type = '5';
                if (!(this.state.file.name.endsWith('.tsv'))) {
                    fileType = '.tsv';
                    validFileExt = false;
                }
            }

            if (validFileExt) {
                formData.append('file_type', type);
                formData.append('file_data', this.state.file);

                axios.post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'x-meta-caption': 'Importing ' + prettyType + ' file...' // triggers loader during the request
                    }
                }).then( (response: AxiosResponse) => {
                    if (response.data !== undefined && response.data.code === 'SUCCESS') {
                        Toast.info(prettyType + ' imported');
                    } else {
                        Toast.error('Import of ' + prettyType + ' failed');
                    }
                }).catch( (error: AxiosResponse) => {
                    // tslint:disable-next-line:no-console
                    console.log('file submit error: ', error);
                    Toast.error('Import of ' + prettyType + ' failed');
                });
            } else {
                this.setState({
                  showModal: true,
                  fileType: fileType
                });
            }
        } else {
            this.setState({
                showModal: true,
                fileType: fileType
            });
        }
    }

    prettyFileType(option: FileType) {
        switch (this.state.importValue) {
            case 'config': return 'Configuration';
            case 'alias': return 'Aliases';
            case 'vodAlias': return 'VOD Aliases';
            default: return 'file';
        }
    }

    exportConfig(url: string, filename: string) {
        axios.get(url, { // need this when downloading binary file
            responseType: 'arraybuffer'
        })
            .then(function (response: AxiosResponse) {
                let stringObject = response.data;
                fileDownload(stringObject, filename);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('Export error: ', error);
            });
    }

    render() {
        const inlineStyle = {
            modal : {
                marginTop: '50px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };

        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                    const sysName = (oauth.sys.name ? oauth.sys.name : 'surveyor-abr');
                    const sysConfigFilename = 'System Config - Download IQConfig-' + this.getSysName(oauth) + '.ini';
                    const aliasFilename = 'Asset Aliases - Download IQStreamAlias-' + this.getSysName(oauth) + '.tsv';
                    const vodAliasFilename = 'VOD Asset Aliases - Download IQStreamVodAlias-' + this.getSysName(oauth) + '.tsv';
                    const fileName = (this.state.exportValue === 'config' ?  'IQConfig-' + this.getSysName(oauth) : this.state.exportValue === 'alias' ? 'IQStreamAlias-' + this.getSysName(oauth) : 'IQStreamVodAlias-' + this.getSysName(oauth));
                    const fileExtension = (this.state.exportValue === 'config' ?  '.ini' : '.tsv');
                    const filename = fileName + fileExtension;
                    // tslint:disable-next-line:max-line-length
                    const exportParams = (this.state.exportValue === 'config' ?  'dataType=SystemConfig&exportFormat=ini&filename=' + filename : this.state.exportValue === 'alias' ? 'dataType=AliasFile&exportFormat=tsv&filename=' + filename : 'dataType=VodAliasFile&exportFormat=tsv&filename=' + filename);
                    let url = (oauth.secureHost ? 'https' : 'http') + '://default/api/export?' + exportParams;
                    return (
                        <React.Fragment>
                            <div className="assetAliasFilters">
                                <Label className="system-config-pageHeader">
                                    Import/Export Configuration
                                </Label>
                            </div>
                            <fieldset id="fieldSet" className="more-padding">
                                <legend>Import Configuration File</legend>
                                <Form onSubmit={(e: any) => this.onImportConfigFile(e, this.state.importValue)}>
                                    <Form.Group grouped>
                                        <Input
                                            type="file"
                                            className="system-config-segment-fileField"
                                            label="Send this file:"
                                            onChange={(e: any) => this.setState({file: e.target.files[0]})}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label id="download-upload-label">
                                            Select the type of file to import from the host to {sysName}. The
                                            system will reset when the import is complete.
                                        </Label>
                                    </Form.Group>
                                    <Form.Group grouped id="import-radio-group">
                                        <Form.Group grouped>
                                            <Radio
                                                label="System Config"
                                                name="radioGroup"
                                                value="config"
                                                checked={this.state.importValue === 'config'}
                                                onChange={(e: any, data: any) => this.setState({importValue: data.value})}
                                            />
                                        </Form.Group>
                                        {!oauth.VODOnlyLicensePresent ?
                                            <Form.Group grouped>
                                                <Radio
                                                    label="Asset Aliases"
                                                    name="radioGroup"
                                                    value="alias"
                                                    checked={this.state.importValue === 'alias'}
                                                    onChange={(e: any, data: any) => this.setState({importValue: data.value})}
                                                />
                                            </Form.Group>
                                        : null}
                                        <OAuth.Feature VOD>
                                            <Form.Group grouped>
                                                <Radio
                                                    label="VOD Asset Aliases"
                                                    name="radioGroup"
                                                    value="vodAlias"
                                                    checked={this.state.importValue === 'vodAlias'}
                                                    onChange={(e: any, data: any) => this.setState({importValue: data.value})}
                                                />
                                            </Form.Group>
                                        </OAuth.Feature>
                                        <OAuth.Feature VODOnly>
                                            <Form.Group grouped>
                                                <Radio
                                                    label="VOD Asset Aliases"
                                                    name="radioGroup"
                                                    value="vodAlias"
                                                    checked={this.state.importValue === 'vodAlias'}
                                                    onChange={(e: any, data: any) => this.setState({importValue: data.value})}
                                                />
                                            </Form.Group>
                                        </OAuth.Feature>
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Button id="download-upload-button" type="submit">
                                            Import
                                        </Button>
                                    </Form.Group>
                                </Form>
                            </fieldset>
                            <fieldset id="fieldSet" className="more-padding">
                                <legend>Export Configuration File</legend>
                                <Form>
                                    <Form.Group grouped>
                                        <Label id="download-upload-label">
                                            Select the type of file to export from {sysName} to the host.
                                        </Label>
                                    </Form.Group>
                                    <Form.Group grouped id="import-radio-group">
                                        <Form.Group grouped>
                                            <Radio
                                                label={sysConfigFilename}
                                                name="radioGroup"
                                                value="config"
                                                checked={this.state.exportValue === 'config'}
                                                onChange={(e: any, data: any) => this.setState({exportValue: data.value})}
                                            />
                                        </Form.Group>
                                        {!oauth.VODOnlyLicensePresent ?
                                            <Form.Group grouped>
                                                <Radio
                                                    label={aliasFilename}
                                                    name="radioGroup"
                                                    value="alias"
                                                    checked={this.state.exportValue === 'alias'}
                                                    onChange={(e: any, data: any) => this.setState({exportValue: data.value})}
                                                />
                                            </Form.Group>
                                        : null}
                                        <OAuth.Feature VOD>
                                            <Form.Group grouped>
                                                <Radio
                                                    label={vodAliasFilename}
                                                    name="radioGroup"
                                                    value="vodAlias"
                                                    checked={this.state.exportValue === 'vodAlias'}
                                                    onChange={(e: any, data: any) => this.setState({exportValue: data.value})}
                                                />
                                            </Form.Group>
                                        </OAuth.Feature>
                                        <OAuth.Feature VODOnly>
                                            <Form.Group grouped>
                                                <Radio
                                                    label={vodAliasFilename}
                                                    name="radioGroup"
                                                    value="vodAlias"
                                                    checked={this.state.exportValue === 'vodAlias'}
                                                    onChange={(e: any, data: any) => this.setState({exportValue: data.value})}
                                                />
                                            </Form.Group>
                                        </OAuth.Feature>
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Button
                                            id="download-upload-button"
                                            content="Export"
                                            onClick={(event, data) => this.exportConfig(url, filename)}
                                        />
                                    </Form.Group>
                                </Form>
                            </fieldset>
                            <Modal
                                open={this.state.showModal}
                                onClose={this.handleWarningClose}
                                size="mini"
                                style={inlineStyle.modal}
                            >
                                <Modal.Header>Error!</Modal.Header>
                                <Modal.Content>
                                    <Form>
                                        <Form.Field>
                                            Please select a {this.state.fileType} {this.prettyFileType(this.state.importValue)} file to upload.
                                        </Form.Field>
                                    </Form>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handleWarningClose}>
                                        Ok
                                    </Button>
                                </Modal.Actions>
                            </Modal>
                        </React.Fragment>
                    );
                }}
            </OAuth.Context>
        );
    }
    handleWarningClose() {
        this.setState({
            showModal: false,
            fileType: ''
        });
    }
    getSysName(oauth: OAuthClientStatus) {
        let now = new Date();
        let url = '';
        let sysName = (oauth.sys.name ? oauth.sys.name : 'surveyor-abr');

        url += sysName + '-';
        url += (now.getFullYear() + ('0' + (now.getUTCMonth() + 1)).slice(-2) + ('0' + now.getDate()).slice(-2));

        return url;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/system/downloadUploadConfig.tsx